import { createFileRoute } from "@tanstack/react-router"
import { ControlPlaneResourceInstanceList } from "@/components/rema"

function ControlPlaneResourceInstancesPage() {
  return (
    <div className="p-6">
      <ControlPlaneResourceInstanceList />
    </div>
  )
}

export const Route = createFileRoute("/rema/control-plane-resource-instances/")({
  staticData: {
    title: 'Manage Resource Instances - Control Plane',
    isSecured: true,
  },
  component: ControlPlaneResourceInstancesPage,
})
